import React from 'react'
import styled from 'styled-components'
import media from '../../utils/media'

const Space = styled.div`
  height: ${props => (props.height ? props.height : 0)}px;
  margin-bottom: ${props => (props.marginB ? props.marginB : 0)}px;
  ${media.mobileL`
    height: ${props => (props.sHeight ? props.sHeight : 0)}px;
    margin-bottom: ${props => (props.marginB ? props.marginB : 0)}px;
  `}
`

const HiddenSpan = styled.div`
  visibility: hidden;
  height: 0;
  font-size: 0;
`

export default function Spacer({ config }) {
  const { height, sHeight, marginB, sMarginB } = config
  return (
    <Space
      height={height}
      sHeight={sHeight}
      marginB={marginB}
      sMarginB={sMarginB}
    >
      <HiddenSpan>h</HiddenSpan>
    </Space>
  )
}
